import { id } from '@swimlane/ngx-charts';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from 'src/app/services/http/http.service';
import { Component, OnInit } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Spinkit } from 'ng-http-loader';

@Component({
  selector: 'app-l2-resto-details',
  templateUrl: './l2-resto-details.component.html',
  styleUrls: ['./l2-resto-details.component.scss']
})
export class L2RestoDetailsComponent implements OnInit {
  editRestoId: any;
  // private _snackBar: any;

  constructor(private httpSv: HttpService, private _snackBar: MatSnackBar, private router: Router,) { }

  ngOnInit(): void {
    this.editRestoId = localStorage.getItem('restoID')
    this.selectAllForDropdownItems(this.getAllergens())
    this.selectAllForDropdownItems(this.getData());
    this.selectAllForDropdownItems(this.getCuisine());
    this.selectAllForDropdownItems(this.getCategory());
    this.updateRestoFunc(this.editRestoId)
  }
  public spinkit = Spinkit;
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  restoEditName: string = "";
  restoEditEmail: string = "";
  restoEditPhone: string = "";
  restoEditAddress: string = "";
  restoEditDescrip: string = "";
  restoEditPocName: string = "";
  restoEditPocId: string = "";
  restoEditLotitude: string = "";
  restoEditLogitude: string = "";
  restoEditServiceCharge: string = "";
  spiceEditTol: string = "";
  noOfEditTable: string = "";
  editOfferValue: string = "";
  restoDescrip: string = "";
  editSrc: string = "../../../assets/images/Ellipse 11.png";
  featureSrc: string = "../../../assets/images/Ellipse 11.png";
  restoEditDecription;
  trusted;
  reviewCount;
  avgRating;
  website;
  street;
  city;
  cities3 = [
    {
      id: 1,
      name: "Website",
      avatar: "../../../assets/images/web-svgrepo-com (1).png",
    },
    {
      id: 2,
      name: "Instagram",
      avatar: "../../../assets/images/instagram-svgrepo-com.png",
    },
    {
      id: 3,
      name: "Facebook",
      avatar: "../../../assets/images/facebook-svgrepo-com.png",
    },
    {
      id: 4,
      name: "Twitter",
      avatar: "../../../assets/images/twitter-svgrepo-com.png",
    },
    {
      id: 5,
      name: "Youtube",
      avatar: "../../../assets/images/youtube-svgrepo-com.png",
    },
  ];

  monOpenHH = ''
  monOpenMM = ''
  monOpenMead = 'am'
  monPrecheck
  monCloseHH = ''
  monCloseMM = ''
  monCloseMead = 'am'
  tueOpenHH = ''
  tueOpenMM = ''
  tueOpenMead = 'am'
  tueCloseHH = ''
  tueCloseMM = ''
  tueCloseMead = 'am'
  tuePrecheck
  wedOpenHH = ''
  wedOpenMM = ''
  wedOpenMead = 'am'
  wedCloseHH = ''
  wedCloseMM = ''
  wedCloseMead = 'am'
  wedPrecheck
  thurOpenHH = ''
  thurOpenMM = ''
  thurOpenMead = 'am'
  thurCloseHH = ''
  thurCloseMM = ''
  thurCloseMead = 'am'
  thurPrecheck
  friOpenHH = ''
  friOpenMM = ''
  friOpenMead = 'am'
  friCloseHH = ''
  friCloseMM = ''
  friCloseMead = 'am'
  friPrecheck
  satOpenHH = ''
  satOpenMM = ''
  satOpenMead = 'am'
  satCloseHH = ''
  satCloseMM = ''
  satCloseMead = 'am'
  satPrecheck
  sunOpenHH = ''
  sunOpenMM = ''
  sunOpenMead = 'am'
  sunCloseHH = ''
  sunCloseMM = ''
  sunCloseMead = 'am'
  sunPrecheck
  mondayClearCondition = false
  tuesdayClearCondition = false
  wednesdayClearCondition = false
  tursdayClearCondition = false
  fridayClearCondition = false
  saturdayClearCondition = false
  sundayClearCondition = false



  offerMonday = false
  offerTuesday = false
  offerWednesday = false
  offerTurusday = false
  offerFriday = false
  offerSaturday = false
  offerSunday = false
  offerMonValue = ''
  offerTueValue = ''
  offerWedValue = ''
  offerThurValue = ''
  offerFriValue = ''
  offerSatValue = ''
  offerSunValue = ''

  queAns = ''

  allDieatary = [];
  allAllergens = []
  allCaategory = []
  allCuisine = []
  selectedDieatry: any = []
  selectedAllegens: any = []
  selectedCaategory: any = []
  selectedCuisine: any = []


  menuSrc: any[] = []
  menuPdfCondition
  menuImgCondition
  pdfConditionMenu: boolean = false
  imgConditionMenu: boolean = false
  menuLinkCondition = false
  menuImgToBeAppend: any[] = []
  menuPdfToBeAppend: any = null
  pdfMenuSrc = 'null'
  pdfRedirctVar: any = null
  featureImgToBeAppend: any = null
  otherDescriptionOrTags = ''
  queAnsOtherText = ''
  closeEditFunc() {
    this.restoEditName = "";
    this.restoEditEmail = "";
    this.restoEditPhone = "";
    this.restoEditAddress = "";
    this.restoEditDescrip = "";
    this.restoEditPocName = "";
    this.restoEditPocId = "";
    this.restoEditLotitude = "";
    this.restoEditLogitude = "";
    this.restoEditServiceCharge = "";
    this.spiceEditTol = "";
    this.noOfEditTable = "";
    this.editOfferValue = "";
    this.editSrc = "../../../assets/images/Ellipse 11.png"
    this.featureSrc = "../../../assets/images/Ellipse 11.png";
    this.monOpenHH = ''
    this.monOpenMM = ''
    this.monOpenMead = 'am'
    this.monPrecheck
    this.monCloseHH = ''
    this.monCloseMM = ''
    this.monCloseMead = 'am'
    this.tueOpenHH = ''
    this.tueOpenMM = ''
    this.tueOpenMead = 'am'
    this.tueCloseHH = ''
    this.tueCloseMM = ''
    this.tueCloseMead = 'am'
    this.tuePrecheck
    this.wedOpenHH = ''
    this.wedOpenMM = ''
    this.wedOpenMead = 'am'
    this.wedCloseHH = ''
    this.wedCloseMM = ''
    this.wedCloseMead = 'am'
    this.wedPrecheck
    this.thurOpenHH = ''
    this.thurOpenMM = ''
    this.thurOpenMead = 'am'
    this.thurCloseHH = ''
    this.thurCloseMM = ''
    this.thurCloseMead = 'am'
    this.thurPrecheck
    this.friOpenHH = ''
    this.friOpenMM = ''
    this.friOpenMead = 'am'
    this.friCloseHH = ''
    this.friCloseMM = ''
    this.friCloseMead = 'am'
    this.friPrecheck
    this.satOpenHH = ''
    this.satOpenMM = ''
    this.satOpenMead = 'am'
    this.satCloseHH = ''
    this.satCloseMM = ''
    this.satCloseMead = 'am'
    this.satPrecheck
    this.sunOpenHH = ''
    this.sunOpenMM = ''
    this.sunOpenMead = 'am'
    this.sunCloseHH = ''
    this.sunCloseMM = ''
    this.sunCloseMead = 'am'
    this.sunPrecheck
    this.mondayClearCondition = false
    this.tuesdayClearCondition = false
    this.wednesdayClearCondition = false
    this.tursdayClearCondition = false
    this.fridayClearCondition = false
    this.saturdayClearCondition = false
    this.sundayClearCondition = false

    this.offerMonday = false
    this.offerTuesday = false
    this.offerWednesday = false
    this.offerTurusday = false
    this.offerFriday = false
    this.offerSaturday = false
    this.offerSunday = false
    this.offerMonValue = ''
    this.offerTueValue = ''
    this.offerWedValue = ''
    this.offerThurValue = ''
    this.offerFriValue = ''
    this.offerSatValue = ''
    this.offerSunValue = ''

    this.queAns = ''

    this.allDieatary = [];
    this.allAllergens = []
    this.allCaategory = []
    this.allCuisine = []
    this.selectedDieatry = []
    this.selectedAllegens = []
    this.selectedCaategory = []
    this.selectedCuisine = []

    this.menuSrc = []
    this.menuPdfCondition
    this.menuImgCondition
    this.pdfConditionMenu = false
    this.imgConditionMenu = false
    this.menuLinkCondition = false
    this.menuImgToBeAppend = []
    this.menuPdfToBeAppend = null
    this.pdfMenuSrc = 'null'
    this.pdfRedirctVar = null
    this.otherDescriptionOrTags = ''
    this.editSendData = new FormData()
  }
  editSendData: any = new FormData()
  oneEditImageChange(event: any,id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(()=>{this._snackBar.dismiss()},3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.editSendData.append("logo", event.target.files[0]);
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.editSrc = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }

  copyTimeFunc(day) {
    if (day == 'tue') {
      this.tueOpenHH = this.monOpenHH
      this.tueOpenMM = this.monOpenMM
      this.tueOpenMead = this.monOpenMead
      this.tueCloseHH = this.monCloseHH
      this.tueCloseMM = this.monCloseMM
      this.tueCloseMead = this.monCloseMead

    }
    else if (day == 'wed') {
      this.wedOpenHH = this.tueOpenHH
      this.wedOpenMM = this.tueOpenMM
      this.wedOpenMead = this.tueOpenMead
      this.wedCloseHH = this.tueCloseHH
      this.wedCloseMM = this.tueCloseMM
      this.wedCloseMead = this.tueCloseMead
    }
    else if (day == 'thur') {
      this.thurOpenHH = this.wedOpenHH
      this.thurOpenMM = this.wedOpenMM
      this.thurOpenMead = this.wedOpenMead
      this.thurCloseHH = this.wedCloseHH
      this.thurCloseMM = this.wedCloseMM
      this.thurCloseMead = this.wedCloseMead
    }
    else if (day == 'fri') {
      this.friOpenHH = this.thurOpenHH
      this.friOpenMM = this.thurOpenMM
      this.friOpenMead = this.thurOpenMead
      this.friCloseHH = this.thurCloseHH
      this.friCloseMM = this.thurCloseMM
      this.friCloseMead = this.thurCloseMead
    }
    else if (day == 'sat') {
      this.satOpenHH = this.friOpenHH
      this.satOpenMM = this.friOpenMM
      this.satOpenMead = this.friOpenMead
      this.satCloseHH = this.friCloseHH
      this.satCloseMM = this.friCloseMM
      this.satCloseMead = this.friCloseMead
    }
    else if (day == 'sun') {
      this.sunOpenHH = this.satOpenHH
      this.sunOpenMM = this.satOpenMM
      this.sunOpenMead = this.satOpenMead
      this.sunCloseHH = this.satCloseHH
      this.sunCloseMM = this.satCloseMM
      this.sunCloseMead = this.satCloseMead
    }

  }
  timeClear(id) {
    if (id == 'mondayTime') {
      this.monOpenHH = ''
      this.monOpenMM = ''
      this.monOpenMead = 'am'
      this.monCloseHH = ''
      this.monCloseMM = ''
      this.monCloseMead = 'am'
    }
    else if (id == 'tuesdayTime') {
      this.tueOpenHH = ''
      this.tueOpenMM = ''
      this.tueOpenMead = 'am'
      this.tueCloseHH = ''
      this.tueCloseMM = ''
      this.tueCloseMead = 'am'
    }
    else if (id == 'wednesTime') {
      this.wedOpenHH = ''
      this.wedOpenMM = ''
      this.wedOpenMead = 'am'
      this.wedCloseHH = ''
      this.wedCloseMM = ''
      this.wedCloseMead = 'am'
    }
    else if (id == 'thursdayTime') {
      this.thurOpenHH = ''
      this.thurOpenMM = ''
      this.thurOpenMead = 'am'
      this.thurCloseHH = ''
      this.thurCloseMM = ''
      this.thurCloseMead = 'am'
    }
    else if (id == "fridayTime") {
      this.friOpenHH = ''
      this.friOpenMM = ''
      this.friOpenMead = 'am'
      this.friCloseHH = ''
      this.friCloseMM = ''
      this.friCloseMead = 'am'
    }
    else if (id == 'saturdayTime') {
      this.satOpenHH = ''
      this.satOpenMM = ''
      this.satOpenMead = 'am'
      this.satCloseHH = ''
      this.satCloseMM = ''
      this.satCloseMead = 'am'
    }
    else if (id == 'sundayTime') {
      this.sunOpenHH = ''
      this.sunOpenMM = ''
      this.sunOpenMead = 'am'
      this.sunCloseHH = ''
      this.sunCloseMM = ''
      this.sunCloseMead = 'am'
    }
  }
  timeInputFunc(day, e) {

    if (e.checked) {
      if (day == 'mondayTime') {
        this.mondayClearCondition = true
        this.monPrecheck = true
      }
      else if (day == 'tuesdayTime') {
        this.tuesdayClearCondition = true
        this.tuePrecheck = true
      }
      else if (day == 'wednesTime') {
        this.wednesdayClearCondition = true
        this.wedPrecheck = true
      }
      else if (day == 'thursdayTime') {
        this.tursdayClearCondition = true
        this.thurPrecheck = true
      }
      else if (day == 'fridayTime') {
        this.fridayClearCondition = true
        this.friPrecheck = true
      }
      else if (day == 'saturdayTime') {
        this.saturdayClearCondition = true
        this.satPrecheck = true
      }
      else if (day == 'sundayTime') {
        this.sundayClearCondition = true
        this.sunPrecheck = true
      }
    }
    else {
      if (day == 'mondayTime') {
        this.timeClear(day)
        this.mondayClearCondition = false
        this.monPrecheck = false
      }
      else if (day == 'tuesdayTime') {
        this.timeClear(day)
        this.tuesdayClearCondition = false
        this.tuePrecheck = false
      }
      else if (day == 'wednesTime') {
        this.timeClear(day)
        this.wednesdayClearCondition = false
        this.wedPrecheck = false
      }
      else if (day == 'thursdayTime') {
        this.timeClear(day)
        this.tursdayClearCondition = false
        this.thurPrecheck = false
      }
      else if (day == 'fridayTime') {
        this.timeClear(day)
        this.fridayClearCondition = false
        this.friPrecheck = false
      }
      else if (day == 'saturdayTime') {
        this.timeClear(day)
        this.saturdayClearCondition = false
        this.satPrecheck = false
      }
      else if (day == 'sundayTime') {
        this.timeClear(day)
        this.sundayClearCondition = false
        this.sunPrecheck = false
      }
    }
    // console.log(this.tuePrecheck, this.monOpenHH,this.monOpenMM,this.monCloseHH,this.monCloseMM)
  }
  onMaterialGroupChange(event) {
    // console.log(event);
  }
  getData() {
    let temp
    this.httpSv.getAllD2Dieatry().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allDieatary = temp
      }
    })
    return (this.allDieatary = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getAllergens() {
    let temp
    this.httpSv.getAllD2DAllergen().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allAllergens = temp
      }
    })
    return (this.allAllergens = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCategory() {
    let temp
    this.httpSv.getAllD2Category().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCaategory = temp
      }
    })
    return (this.allCaategory = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCuisine() {
    let temp
    this.httpSv.getAllD2Cuisine().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCuisine = temp
      }
    })
    return (this.allCuisine = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  selectAllForDropdownItems(items: any[]) {
    let allSelect = (items) => {
      items.forEach((element) => {
        element['id'] = 'selectedAllGroup';
      });
    };

    allSelect(items);
  }
  onFeatureImgChange(event,id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(()=>{this._snackBar.dismiss()},3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.featureImgToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.featureSrc = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  offerHandelFunc(day, e) {
    if (e.checked) {
      if (day == 'mon') {
        this.offerMonday = true
      }
      else if (day == 'tue') {
        this.offerTuesday = true
      }
      else if (day == 'wed') {
        this.offerWednesday = true
      }
      else if (day == 'thu') {
        this.offerTurusday = true
      }
      else if (day == 'fri') {
        this.offerFriday = true
      }
      else if (day == 'sat') {
        this.offerSaturday = true
      }
      else if (day == 'sun') {
        this.offerSunday = true
      }
    }
    else {
      if (day == 'mon') {
        this.offerMonday = false
      }
      else if (day == 'tue') {
        this.offerTuesday = false
      }
      else if (day == 'wed') {
        this.offerWednesday = false
      }
      else if (day == 'thu') {
        this.offerTurusday = false
      }
      else if (day == 'fri') {
        this.offerFriday = false
      }
      else if (day == 'sat') {
        this.offerSaturday = false
      }
      else if (day == 'sun') {
        this.offerSunday = false
      }

    }
  }
  preRadioSelect(option) {
    if (option == this.queAns) return true
    else false
  }
  menuImgDelete(index, src) {
    if (src.src.includes('base64')) {
      let reqIndex = this.menuImgToBeAppend.findIndex(ele => ele.name == src.name)
      this.menuSrc.splice(index, 1)
      this.menuImgToBeAppend.splice(reqIndex, 1)
    }
    else {
      this.menuSrc.splice(index, 1)
    }
  }
  onMenuChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(()=>{this._snackBar.dismiss()},3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.menuLinkCondition = false
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      let temp = event.target.files[0].name.split('.')
      if (temp[temp.length - 1] != 'pdf') {
        this.menuImgToBeAppend.push(event.target.files[0])
        this.menuPdfToBeAppend = null
        this.menuSrc.push({ src: e.target.result, name: event.target.files[0].name })
        document.getElementById(id)['value'] = ''
      }
      else {
        this.pdfUploadCheckFunc(event, id)
      }
    }
  }
  pdfUploadCheckFunc(data, id) {
    if (this.menuSrc.length != 0) {
      let con = confirm('Are you sure to upload the pdf , this will delete the images')
      if (con) {
        this.menuSrc = []
        this.menuImgToBeAppend = []
        this.onMenuPdfChange(data, id)

      }
      else {
        document.getElementById(id)['value'] = ''
      }
    }
    else {
      this.onMenuPdfChange(data, id)
    }
  }
  onMenuPdfChange(event, id) {
    this.menuPdfToBeAppend = event.target.files[0]
    this.pdfMenuSrc = event.target.files[0].name
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.pdfRedirctVar = e.target.result
      document.getElementById(id)['value'] = ''
      this.menuSrc = []
      this.menuImgToBeAppend = []
    };

  }
  openpdf() {
    window.open(this.pdfRedirctVar)
  }
  pdfDelete() {
    if (this.menuImgToBeAppend) {
      this.pdfMenuSrc = 'null'
      this.menuPdfToBeAppend = null
    }
  }
  updateRestoFunc(id: any) {
    // this.editRestoId = window.atob(id);
    this.editRestoId = id;
    this.httpSv.getOneRestoDetails(this.editRestoId).subscribe((res) => {
      if (res["status"] == "TRUE") {
        // console.log(res);
        let temp = res["result"].data;
        this.restoEditName = temp.restaurant_name;
        this.restoEditEmail = temp.restaurant_email;
        this.restoEditPhone = temp.restaurant_telephone;
        this.restoEditAddress = temp.restaurant_address;
        // this.restoEditDescrip = temp.
        this.restoEditPocName = temp.restaurant_poc_name;
        this.restoEditPocId = temp.restaurant_poc_number;
        this.restoEditLotitude = temp.restaurant_lat;
        this.restoEditLogitude = temp.restaurant_long;
        this.restoEditDecription = temp.description;
        this.trusted = temp.trusted
        this.reviewCount = temp.review_count
        this.avgRating = temp.average_rating
        this.website = temp.website
        this.street = temp.street
        this.city = temp.city
        this.restoEditServiceCharge = temp.restaurant_service_charge;
        this.spiceEditTol = temp.restaurant_spice_tollerence;
        this.noOfEditTable = temp.restaurant_no_of_tables;
        // this.editOfferValue = temp.
        this.editSrc = temp.logo;
        // this.editSrc = temp.restaurant_image;
        if (temp.categories) {
          if (temp.categories.length > 0)
            this.selectedCaategory = temp.categories.map(ele => ele.id)
        }
        if (temp.cuisine) {
          if (temp.cuisine.length > 0)
            this.selectedCuisine = temp.cuisine.map(ele => ele.id)
        }
        if (temp.dietary_preferences) {
          if (temp.dietary_preferences.length > 0)
            this.selectedDieatry = temp.dietary_preferences.map(ele => ele.id)
        }
        if (temp.allergens) {
          if (temp.allergens.length > 0)
            this.selectedAllegens = temp.allergens.map(ele => ele.id)
           
        }
        if (temp.featured_image) {
          this.featureSrc = temp.featured_image
        }
        if (temp.opening_hours) {
          let time = temp.opening_hours.split(',')
          time.forEach(element => {
            let day = element.split(':')[0]
            let temp1 = element.split(':')
            if (day == 'Monday') {
              if (temp1[1] != 'null') {
                this.monOpenHH = temp1[1]
                this.monOpenMM = temp1[2]
                this.monOpenMead = temp1[3]
                this.monCloseHH = temp1[4]
                this.monCloseMM = temp1[5]
                this.monCloseMead = temp1[6]
                this.monPrecheck = true
                this.mondayClearCondition = true
              }
            }
            else if (day == 'Tuesday') {
              if (temp1[1] != 'null') {
                this.tueOpenHH = temp1[1]
                this.tueOpenMM = temp1[2]
                this.tueOpenMead = temp1[3]
                this.tueCloseHH = temp1[4]
                this.tueCloseMM = temp1[5]
                this.tueCloseMead = temp1[6]
                this.tuePrecheck = true
                this.tuesdayClearCondition = true
              }
            }
            else if (day == 'Wednesday') {
              if (temp1[1] != 'null') {
                this.wedOpenHH = temp1[1]
                this.wedOpenMM = temp1[2]
                this.wedOpenMead = temp1[3]
                this.wedCloseHH = temp1[4]
                this.wedCloseMM = temp1[5]
                this.wedCloseMead = temp1[6]
                this.wedPrecheck = true
                this.wednesdayClearCondition = true
              }
            }
            else if (day == 'Thursday') {
              if (temp1[1] != 'null') {
                this.thurOpenHH = temp1[1]
                this.thurOpenMM = temp1[2]
                this.thurOpenMead = temp1[3]
                this.thurCloseHH = temp1[4]
                this.thurCloseMM = temp1[5]
                this.thurCloseMead = temp1[6]
                this.thurPrecheck = true
                this.tursdayClearCondition = true

              }
            }
            else if (day == 'Friday') {
              if (temp1[1] != 'null') {
                this.friOpenHH = temp1[1]
                this.friOpenMM = temp1[2]
                this.friOpenMead = temp1[3]
                this.friCloseHH = temp1[4]
                this.friCloseMM = temp1[5]
                this.friCloseMead = temp1[6]
                this.friPrecheck = true
                this.fridayClearCondition = true
              }
            }
            else if (day == 'Saturday') {
              if (temp1[1] != 'null') {
                this.satOpenHH = temp1[1]
                this.satOpenMM = temp1[2]
                this.satOpenMead = temp1[3]
                this.satCloseHH = temp1[4]
                this.satCloseMM = temp1[5]
                this.satCloseMead = temp1[6]
                this.satPrecheck = true
                this.saturdayClearCondition = true
              }
            }
            else {
              if (temp1[1] != 'null') {
                this.sunOpenHH = temp1[1]
                this.sunOpenMM = temp1[2]
                this.sunOpenMead = temp1[3]
                this.sunCloseHH = temp1[4]
                this.sunCloseMM = temp1[5]
                this.sunCloseMead = temp1[6]
                this.sunPrecheck = true
                this.sundayClearCondition = true
              }
            }
          });
        }
        if (temp.special_offer) {
          let offersArr = temp.special_offer.split(',')
          offersArr.forEach(element => {
            let day = element.split(':')[0]
            let temp1 = element.split(':')
            if (day == 'Monday') {
              if (temp1[1] != 'null') {
                this.offerMonday = true
                this.offerMonValue = temp1[1]
              }
            }
            else if (day == 'Tuesday') {
              if (temp1[1] != 'null') {
                this.offerTuesday = true
                this.offerTueValue = temp1[1]
              }
            }
            else if (day == 'Wednesday') {
              if (temp1[1] != 'null') {
                this.offerWednesday = true
                this.offerWedValue = temp1[1]
              }
            }
            else if (day == 'Thursday') {
              if (temp1[1] != 'null') {
                this.offerTurusday = true
                this.offerThurValue = temp1[1]

              }
            }
            else if (day == 'Friday') {
              if (temp1[1] != 'null') {
                this.offerFriday = true
                this.offerFriValue = temp1[1]
              }
            }
            else if (day == 'Saturday') {
              if (temp1[1] != 'null') {
                this.offerSaturday = true
                this.offerSatValue = temp1[1]
              }
            }
            else {
              if (temp1[1] != 'null') {
                this.offerSunday = true
                this.offerSunValue = temp1[1]
              }
            }
          });
        }
        if (temp.appropriate_food_allergy_message) {
          if (temp.appropriate_food_allergy_message == 'A' || temp.appropriate_food_allergy_message == 'B' || temp.appropriate_food_allergy_message == 'C')
            this.queAns = temp.appropriate_food_allergy_message
            else {
              this.queAns = 'D'
              this.queAnsOtherText = temp.appropriate_food_allergy_message
            }
        }
        if (temp.menu_name) {
          if (temp.menu_name[0].includes('.pdf')) {
            this.menuPdfCondition = true
            this.pdfRedirctVar = temp.menu_name[0]
            let splitArr = temp.menu_name[0].split('/')
            this.pdfMenuSrc = splitArr[splitArr.length - 1]
            this.pdfConditionMenu = true
          }
          else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
            this.menuImgCondition = true
            temp.menu_name.forEach(element => {
              this.menuSrc.push({ src: element })
            });
            this.imgConditionMenu = true
          }
        }
        else if (temp.menu_name_link) {
          let menuNameLink = temp.menu_name_link
          if (menuNameLink[0].includes('.pdf')) {
            this.menuPdfCondition = true
            this.pdfRedirctVar = temp.menu_name[0]
            let splitArr = temp.menu_name[0].split('/')
            this.pdfMenuSrc = splitArr[splitArr.length - 1]
            this.pdfConditionMenu = true
          }
          else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
            // console.log('works 2')
            this.menuImgCondition = true
            menuNameLink.forEach(element => {
              this.menuSrc.push({ src: element })
            });
            this.imgConditionMenu = true
          }
        }
        if (temp.description_and_tags) {
          this.otherDescriptionOrTags = temp.description_and_tags
        }
        if (temp.delivery_partner) {
          let deliverArr = temp.delivery_partner.split(',')
          console.log(deliverArr)
          deliverArr.forEach(element => {
            let [partnerName, ...temp1] = element.split(':')
            temp1 = temp1.join(':')
            // console.log(partnerName, temp1)
            // let temp1 = element.split(':')
            if (partnerName == 'Deliveroo') {
              if (temp1 != 'null') {
                this.delverooCon = true
                this.delverooVal = temp1
              }
            }
            else if (partnerName == 'JustEat') {
              if (temp1 != 'null') {
                this.justEatCon = true
                this.justEatVal = temp1
              }
            }
            else if (partnerName == 'UberEats') {
              if (temp1 != 'null') {
                this.uberEatsCon = true
                this.uberEatsVal = temp1
              }
            }
            else if (partnerName == 'Foodstuff') {
              if (temp1 != 'null') {
                this.foodstuffCon = true
                this.foodstuffVal = temp1
              }
            }

          });
        }
        if (temp.instagram_link && temp.instagram_link != 'NA' && temp.instagram_link != 'null') {
          this.instagramCon = true
          this.instagramVal = temp.instagram_link
        }
        if (temp.social_link) {
          this.facebookCon = true
          this.facebookVal = temp.social_link
        }
        if (temp.google_map_url && temp.google_map_url != 'null') {
          this.googleMapCon = true
          this.googleMapVal = temp.google_map_url
        }
      }
    });
  }
  submitEditRestoCreate(formData) {
    if (formData) {
      this.editSendData.append('name', this.restoEditName)
      this.editSendData.append('email', this.restoEditEmail)
      if (this.restoEditPocId) this.editSendData.append('poc_id', this.restoEditPocId)
      else this.editSendData.append('poc_id', 'N/A')
      if (this.restoEditPocName) this.editSendData.append('poc_name', this.restoEditPocName)
      else this.editSendData.append('poc_name', 'N/A')
      this.editSendData.append('address', this.restoEditAddress)
      this.editSendData.append('telephone', this.restoEditPhone)
      this.editSendData.append('spice_tollerence_level', this.spiceEditTol)
      if (this.restoEditServiceCharge) this.editSendData.append('service_charge', this.restoEditServiceCharge)
      else this.editSendData.append('service_charge', 'N/A')
      this.editSendData.append('restaurant_lat', this.restoEditLotitude)
      this.editSendData.append('restaurant_long', this.restoEditLogitude)
      if (this.noOfEditTable) this.editSendData.append('no_of_tables', this.noOfEditTable)
      else this.editSendData.append('no_of_tables', 'N/A')
      this.editSendData.append('restaurant_id', this.editRestoId)


      this.editSendData.append('category', this.selectedCaategory)
      this.editSendData.append('cuisine', this.selectedCuisine)
      this.editSendData.append('allergens', this.selectedAllegens)
      this.editSendData.append('dietary_preferences', this.selectedDieatry)


      if (this.featureSrc != '../../../assets/images/Ellipse 11.png') {
        if (this.featureImgToBeAppend) this.editSendData.append('featured_image', this.featureImgToBeAppend)
        else this.editSendData.append('featured_image', this.featureSrc)
      }
      let mon = this.monPrecheck ? "Monday:" + this.monOpenHH + ":" + this.monOpenMM + ":" + this.monOpenMead + ':' + this.monCloseHH + ':' + this.monCloseMM + ':' + this.monCloseMead : "Monday:null"
      let tue = this.tuePrecheck ? `Tuesday:${this.tueOpenHH}:${this.tueOpenMM}:${this.tueOpenMead}:${this.tueCloseHH}:${this.tueCloseMM}:${this.tueCloseMead}` : 'Tuesday:null'
      let wed = this.wedPrecheck ? `Wednesday:${this.wedOpenHH}:${this.wedOpenMM}:${this.wedOpenMead}:${this.wedCloseHH}:${this.wedCloseMM}:${this.wedCloseMead}` : 'Wednesday:null'
      let thur = this.thurPrecheck ? `Thursday:${this.thurOpenHH}:${this.thurOpenMM}:${this.thurOpenMead}:${this.thurCloseHH}:${this.thurCloseMM}:${this.thurCloseMead}` : 'Thursday:null'
      let fri = this.friPrecheck ? `Friday:${this.friOpenHH}:${this.friOpenMM}:${this.friOpenMead}:${this.friCloseHH}:${this.friCloseMM}:${this.friCloseMead}` : 'Friday:null'
      let sat = this.satPrecheck ? `Saturday:${this.satOpenHH}:${this.satOpenMM}:${this.satOpenMead}:${this.satCloseHH}:${this.satCloseMM}:${this.satCloseMead}` : 'Saturday:null'
      let sun = this.sunPrecheck ? `Sunday:${this.sunOpenHH}:${this.sunOpenMM}:${this.sunOpenMead}:${this.sunCloseHH}:${this.sunCloseMM}:${this.sunCloseMead}` : 'Sunday:null'
      let time = `${mon},${tue},${wed},${thur},${fri},${sat},${sun}`
      this.editSendData.append('opening_hours', time)
      let monOffer = this.offerMonday ? "Monday:" + this.offerMonValue : "Monday:null"
      let tueOffer = this.offerTuesday ? "Tuesday:" + this.offerTueValue : "Tuesday:null"
      let wedOffer = this.offerWednesday ? "Wednesday:" + this.offerWedValue : "Wednesday:null"
      let thurOffer = this.offerTurusday ? "Thursday:" + this.offerThurValue : "Thursday:null"
      let friOffer = this.offerFriday ? "Friday:" + this.offerFriValue : "Friday:null"
      let satOffer = this.offerSaturday ? "Saturday:" + this.offerSatValue : "Saturday:null"
      let sunOffer = this.offerSunday ? "Sunday:" + this.offerSunValue : "Sunday:null"
      let finalOffer = `${monOffer},${tueOffer},${wedOffer},${thurOffer},${friOffer},${satOffer},${sunOffer}`
      this.editSendData.append('special_offer', finalOffer)
      if (this.queAns && this.queAns != 'D') this.editSendData.append('appropriate_food_allergy_message', this.queAns)
      else if(this.queAns && this.queAns == 'D') this.editSendData.append('appropriate_food_allergy_message', this.queAnsOtherText)
      if (this.pdfRedirctVar) {
        if (this.menuPdfToBeAppend) {
          this.editSendData.append('menu_name[]', this.menuPdfToBeAppend)
        }
        else {
          this.editSendData.append('menu_name_link[]', this.pdfMenuSrc)
        }
      }
      else if (this.menuSrc.length > 0) {
        let link: any = []
        if (this.menuSrc.length == this.menuImgToBeAppend.length) {
          this.menuImgToBeAppend.forEach(ele => {
            this.editSendData.append('menu_name[]', ele)
          })
        }
        else {
          if (this.menuImgToBeAppend.length > 0) {
            this.menuImgToBeAppend.forEach(ele => {
              this.editSendData.append('menu_name[]', ele)
            })
          }
          this.menuSrc.forEach(ele => {
            // if (ele.src.includes('http')) this.sendData.append('menu_name_link[]', ele.src)
            if (ele.src.includes('http')) link.push(ele.src)
          })
          this.editSendData.append('menu_name_link[]', link)
        }
      }
      let deleviroo = this.delverooCon ? 'Deliveroo:' + this.delverooVal : 'Deliveroo:null'
      let justeat = this.justEatCon ? 'JustEat:' + this.justEatVal : 'JustEat:null'
      let ubereat = this.uberEatsCon ? 'UberEats:' + this.uberEatsVal : 'UberEats:null'
      let foodstuf = this.foodstuffCon ? 'Foodstuff:' + this.foodstuffVal : 'Foodstuff:null'
      let deleveryPartner = `${deleviroo},${justeat},${ubereat},${foodstuf}`
      this.editSendData.append('delivery_partner', deleveryPartner)
      if (this.instagramCon) this.editSendData.append('instagram_link', this.instagramVal)
      else this.editSendData.append('instagram_link', null)
      if (this.facebookCon) this.editSendData.append('social_link', this.facebookVal)
      if (this.googleMapCon) this.editSendData.append('google_map_url', this.googleMapVal)
      else this.editSendData.append('google_map_url', null)
      if (this.otherDescriptionOrTags.length > 0) this.editSendData.append('description_and_tags', this.otherDescriptionOrTags)
      this.httpSv.updateRestaurant(this.editSendData).subscribe(res => {
        if (res["status"] == true) {
          this.closeEditFunc()
          this._snackBar.open("Restaurant details is updated");
          this.router.navigate(['/public/sign-in'])
          localStorage.clear()
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
        } else {
          this._snackBar.open(res["message"]);
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
        }
      }, (err: any) => {
        this._snackBar.open("Oops! something went wrong");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
        console.log(err);
      })

    }

  }
  delverooCon = false
  justEatCon = false
  uberEatsCon = false
  foodstuffCon = false
  delverooVal
  justEatVal
  uberEatsVal
  foodstuffVal
  delevryHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'deliveroo') this.delverooCon = true
      else if (name == 'justEat') this.justEatCon = true
      else if (name == 'uberEats') this.uberEatsCon = true
      else if (name == 'foodstuff') this.foodstuffCon = true
    }
    else {
      if (name == 'deliveroo') this.delverooCon = false
      else if (name == 'justEat') this.justEatCon = false
      else if (name == 'uberEats') this.uberEatsCon = false
      else if (name == 'foodstuff') this.foodstuffCon = false
    }
  }
  instagramCon = false
  facebookCon = false
  googleMapCon = false
  instagramVal
  facebookVal
  googleMapVal
  socialLinkHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'facebook') this.facebookCon = true
      else if (name == 'instagram') this.instagramCon = true
      else if (name == 'googleMap') this.googleMapCon = true
    }
    else {
      if (name == 'facebook') this.facebookCon = false
      else if (name == 'instagram') this.instagramCon = false
      else if (name == 'googleMap') this.googleMapCon = false
    }
  }
  validate(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57));
  }
  validateNum(event){
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57) || k == 43 || k == 32);
  }
}
